export interface AiAgentConfigurationResult {
    identifier: string;
    raftCommandIndex: number;
}
